import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { HttpCode } from 'types';
import { HTTP_CODE } from 'common/constants';
import { getModelErrorCode } from 'features/page-model/ducks/get-model';

export function useErrorCode() {
  const model = useSelector(getModelErrorCode);

  const [code, setCode] = useState<HttpCode | null>(null);

  const error = useMemo(() => [model].find(Boolean), [model]);

  useEffect(() => {
    if (error) {
      if (error === HTTP_CODE.NOT_FOUND) {
        setCode(error);
      } else {
        setCode(HTTP_CODE.SERVER_ERROR);
      }
    }
  }, [error]);

  return code;
}
